const baseCSSClassname = "btn"

const RaisedButton = ({onClick, ...props}) => {
    const className = `${baseCSSClassname} ${baseCSSClassname}-raised`
    return <div className={className} {...props} onClick={onClick}></div>
}

export default RaisedButton